export enum BreakpointQueries {
  xs = '(max-width: 575px)',
  sm = '(min-width: 576px)',
  md = '(min-width: 768px)',
  lg = '(min-width: 992px)',
  xl = '(min-width: 1200px)',
}
